// ============================================================================
// TrimaThanks — Final screen after all 4 cadrans are validated
// ============================================================================
// BE has already received cadran 4's selections and triggered the email send.
// This screen is purely informational. On CTA, redirect to home.
// ============================================================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ReactComponent as PixChecked } from 'assets/svg/questionnaire-checked.svg';
import Button from 'components/common/button/Button';
import { ROUTES } from 'constants/routes';
import { TrimaThanksWrapper } from 'pages/questionnaire-trima/slides/thanks/TrimaThanks.styled';

const TrimaThanks: React.FC = () => {
  const { t } = useTranslation('trima');
  const history = useHistory();

  return (
    <TrimaThanksWrapper>
      <div className="trima-check" aria-hidden="true">
        <PixChecked />
      </div>

      <h1>{t('thanks.title')}</h1>

      <p className="trima-thanks-body">{t('thanks.body')}</p>

      <p className="trima-thanks-spam">📧 {t('thanks.spam-note')}</p>

      <div className="trima-thanks-cta">
        <Button fill="solid" color="accent" expand onClick={() => history.push(ROUTES.INDEX)}>
          <span>{t('thanks.cta-home')}</span>
        </Button>
      </div>
    </TrimaThanksWrapper>
  );
};

export default TrimaThanks;
